import { render, staticRenderFns } from "./MonthlyComparisonMobile.vue?vue&type=template&id=5827f126&scoped=true"
import script from "./MonthlyComparisonMobile.vue?vue&type=script&lang=js"
export * from "./MonthlyComparisonMobile.vue?vue&type=script&lang=js"
import style0 from "./MonthlyComparisonMobile.vue?vue&type=style&index=0&id=5827f126&prod&scoped=true&lang=css"
import style1 from "./MonthlyComparisonMobile.vue?vue&type=style&index=1&id=5827f126&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827f126",
  null
  
)

export default component.exports